// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"spinner_spinnerWrapper__VeWVN","spinnerSm":"spinner_spinnerSm__BH+Sd","spinnerMd":"spinner_spinnerMd__aJf-v","spinnerLg":"spinner_spinnerLg__9q0Ia"};